import * as React from "react";

import FinishCardContent from "../FinishCardContent";

type TFinishCardModalProps = {
  quizUrl: string | null;
  quizQuestionCount: number | null;
  todoUrl: string | null;
  todoAction: string | null;
  caseSummaryUrl: string;
  title: string;
  timeOnCase: string | null;
};

const FinishCardModal = ({
  quizUrl,
  quizQuestionCount,
  todoUrl,
  todoAction,
  caseSummaryUrl,
  title,
  timeOnCase,
}: TFinishCardModalProps) => (
  <div data-controller="modal">
    <div className="gen-modal" data-modal-target="modal" id="finish_card_modal">
      <div
        className="gen-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="finish_card_heading"
        aria-describedby="finish_card_body"
      >
        <div className="finish-card">
          {quizUrl && (
            <div className="finish-card-image-container">
              <img
                alt=""
                className="finish-card-image"
                aria-hidden="true"
              />
            </div>
          )}
          <FinishCardContent
            quizUrl={quizUrl ?? undefined}
            quizQuestionCount={quizQuestionCount ?? undefined}
            todoUrl={todoUrl ?? undefined}
            todoAction={todoAction ?? undefined}
            caseSummaryUrl={caseSummaryUrl}
            title={title}
            timeOnCase={timeOnCase ?? undefined}
            onSummaryClick={() => {}}
            showQuizImage={true}
            forModal
          />
        </div>
        <div className="gen-modal-header-right">
          <button
            type="button"
            className="close-btn"
            aria-label="Close dialog"
            onClick={() => {
              if (typeof window !== "undefined" && window.localStorage) {
                localStorage.removeItem("showModal");
              }
            }}
            data-action="click->modal#close"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default React.memo(FinishCardModal);
